import { countries } from '../../../../lib/constants';

import SelectInput from '../../../../components/Forms/SelectInput';
import TextInput from '../../../../components/Forms/TextInput';

interface ICompanyFormProps {
  formik: any;
}

function CompanyForm({ formik }: ICompanyFormProps) {
  const { values, touched, errors } = formik;

  const handleChange = (e: any) => {
    formik.setFieldValue('companyUpdated', true);
    formik.handleChange(e);
  };

  return (
    <div className="user-details-form-group">
      <h2>Information entreprise</h2>
      <TextInput
        label="Nom de l'entreprise"
        name="name"
        value={values.name}
        handleChange={handleChange}
        error={touched.name && Boolean(errors.name)}
        helperText={touched.name && errors.name}
      />
      <TextInput
        label="Siret"
        name="siret"
        value={values.siret}
        handleChange={handleChange}
        error={touched.siret && Boolean(errors.siret)}
        helperText={touched.siret && errors.siret}
      />
      <TextInput
        label="Adresse postale"
        name="address"
        value={values.address}
        handleChange={handleChange}
        error={touched.address && Boolean(errors.address)}
        helperText={touched.address && errors.address}
      />
      <div className="user-details-form-group-sub">
        <TextInput
          label="Ville"
          name="city"
          value={values.city}
          handleChange={handleChange}
          error={touched.city && Boolean(errors.city)}
          helperText={touched.city && errors.city}
        />
        <TextInput
          label="Code postal"
          name="postalCode"
          value={values.postalCode}
          handleChange={handleChange}
          error={touched.postalCode && Boolean(errors.postalCode)}
          helperText={touched.postalCode && errors.postalCode}
        />
      </div>
      <SelectInput
        name="country"
        value={values.country}
        handleChange={formik.handleChange}
        label="Pays"
        items={countries}
      />
    </div>
  );
}

export default CompanyForm;
